<template>
    <v-container>
        <v-row :class="'gradient-'+color" class="px-5 text-shadow">
            <v-col cols="12">
                <h1 v-if="is_h1" data-aos="fade-right" class="text-h4 text-md-h3 text-lg-h2" v-html="title"></h1>
                <h2 v-if="!is_h1" data-aos="fade-right" class="text-h4 text-md-h3 text-lg-h2" v-html="title"></h2>
            </v-col>
            <v-col cols="10" md="8" offset="2" offset-md="1">
                <div v-if="sub_title">
                    <h2 v-if="is_h1" data-aos="fade-right" data-aos-delay="50" class="text-h5 text-md-h4 text-lg-h4"  v-html="sub_title"></h2>
                    <h3 v-if="!is_h1" data-aos="fade-right" data-aos-delay="50" class="text-h5 text-md-h4 text-lg-h4"  v-html="sub_title"></h3>
                </div>
            </v-col>
            <v-col cols="10" offset="2" offset-md="1" data-aos="fade-right" data-aos-delay="150" v-if="button">
                <v-hover>
                    <template v-slot:default="{ isHovering, props }">
                        <v-btn 
                            :to="(button.route) ? button.route : button.link"
                            class="btn-primelinks" 
                            v-bind="props"
                            variant="text" 
                            :active="false"
                            :class="isHovering ? button.class : 'ps-0 '+button.class" 
                            :color="button.color">
                            <span class="text-underline">{{button.text}}</span>
                            <v-icon class="ms-3">{{button.icon}}</v-icon>
                        </v-btn>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
   props:{
        title:{
            required: false,
            type: String,
            default: null,
        },
        sub_title:{
            required: false,
            type: String,
            default: null,
        },
        color:{
            required: false,
            type: String,
            default: "black"
        },
        button:{
            required: false,
            type: Object,
        },
        is_h1:{
            required: false,
            type: Boolean,
            default: true
        }
   },
   mounted(){
   }
}
</script>
<style scoped>
.gradient-black{
    color: light;
}
.gradient-white{
    color: #333;
}
</style>